import { InspectionPage } from './inspection-area.model';
import { PropertyState } from './inspection.model';

export class InspectionStepModel {
  readonly propertyState: PropertyState;
  readonly propertyStateCount: number;
  readonly fileUploadCount: number;
  readonly notesCount: number;
  readonly imagesCount: number;
  readonly note: string;
  readonly files: { fileUploadId: number }[];
  readonly questions: [string, boolean][];

  constructor(public readonly page: InspectionPage, public readonly stepNumber: number) {
    const questionsElms = page.elements?.find(elm => elm.type === 'panel' && elm.elements.length)?.elements;
    const noteElms = page.elements?.filter(elm => elm.type === 'comment');
    const fileElms = page.elements?.filter(elm => elm.type === 'file');
    const stateElms = page.elements?.filter(elm => elm.type === 'propertystate');

    this.questions = questionsElms?.map(qElm => [qElm.title, qElm?.isRequired ? qElm.value === 'true' : true]);
    this.notesCount = noteElms?.length ?? 0;
    this.fileUploadCount = fileElms?.length ?? 0;
    this.propertyStateCount = stateElms?.length ?? 0;
    this.imagesCount = page.mainImage?.length ?? 0;

    this.note = noteElms?.[0]?.value ?? '';
    this.files = page.mainImage;
    this.propertyState = this.propertyStateCount ? (stateElms[0].value as PropertyState) : undefined;
  }

  get isCustomStep() {
    return this.notesCount === 1 && this.fileUploadCount === 1 && this.propertyStateCount === 0;
  }

  get flagsCount() {
    return 0; // TODO
  }
}
